module.exports = __webpack_public_path__ + "static/media/Slider 2 5.993079b0.jpg";